import {AfterViewInit, Component, ElementRef, OnDestroy, OnInit, Input, ViewChild} from '@angular/core';
import {Observable, from} from "rxjs";
 
import {Subscription} from "rxjs"; 
import {delay, map} from 'rxjs/operators';
import * as moment from 'moment';
import { Socket } from 'ngx-socket-io';
import {AnalyticService} from '../../../shared/services/analytic.service'
import { NbDialogRef, NbToastrService } from '@nebular/theme';
 
@Component({
  selector: 'app-stat-modal-keys', 
  templateUrl: './stat-modal-keys.component.html',
  styleUrls: ['./stat-modal-keys.component.scss'],
  
})
export class StatModalKeysComponent implements OnInit, OnDestroy, AfterViewInit{
 
    lSub$:any;
    keys:any;

    @Input() stream_id = false;
   @Input() pub = false;
   @Input() stat_id = '';
  loading:boolean = true;

   
  constructor(  private analyticService: AnalyticService,  protected ref: NbDialogRef<StatModalKeysComponent>  ){
  }
   
 
   ngOnInit() {  

	if(!this.pub){
    this.lSub$ = this.analyticService.getKeys(this.stream_id).subscribe((data) =>{
		this.keys = data
			
		this.loading = false
	}) /**/
  	}else{

   this.lSub$ = this.analyticService.getPubKeys(this.stat_id).subscribe((data) =>{
		this.keys = data
			
		this.loading = false
	}) /**/


	}
  }


 


  
   ngAfterViewInit() {
 
   }
 
   ngOnDestroy() {
   	if(this.lSub$){
		this.lSub$.unsubscribe()
	}
   }
 

  close(){
	this.ref.close()
  }
   
  loadKeys(){
     let out = '';


	for(let key of this.keys){
		var status =  key.used ? ' - так' : '';
	out += `${key.password}${status}
`
	}

	if(out){
	   this.downloadKeysInTxt(out)
	}
  }
 

  downloadKeysInTxt(text){
      this.saveTextAsFile( text, 'keys.txt')
   }


     saveTextAsFile (data, filename){

    if(!data) {
        console.error('Console.save: No data')
        return;
    }

    if(!filename) filename = 'file.txt'
	
	 

    var blob = new Blob([data], {type: 'text/plain'}),
        e    = document.createEvent('MouseEvents'),
        a    = document.createElement('a')
 

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, filename);
        }
        else{
          var e = document.createEvent('MouseEvents'),
              a = document.createElement('a');

          a.download = filename;
          a.href = window.URL.createObjectURL(blob);
          a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
         /* e.initEvent('click', true, false, window,
              0, 0, 0, 0, 0, false, false, false, false, 0, null); */
		e.initEvent('click')
          a.dispatchEvent(e);
        }
  }
  
}
